import collectionCommand from './collection-command';
import resourceAction from './resource-action';
import resourceCommand from './resource-command';
import { _normalize } from './serialize-and-push';

export const collectionCmd = collectionCommand;
export const instanceCmd = resourceCommand;

export { resourceAction, resourceCommand, collectionCommand, _normalize };
